import { render, staticRenderFns } from "./AdPlacementWidget.vue?vue&type=template&id=362d6a86&"
import script from "./AdPlacementWidget.vue?vue&type=script&lang=js&"
export * from "./AdPlacementWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('362d6a86')) {
      api.createRecord('362d6a86', component.options)
    } else {
      api.reload('362d6a86', component.options)
    }
    module.hot.accept("./AdPlacementWidget.vue?vue&type=template&id=362d6a86&", function () {
      api.rerender('362d6a86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dynamic-list-items/widgets/AdPlacementWidget.vue"
export default component.exports